export default __webpack_public_path__ + "static/media/organizationinfo-icon.547e0cd8.svg";